import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { cargarParametros } from '../../../helpers/funciones'
import i18n from '../../../lang/idiomas'
import LineaCarritoExtrusion from './LineaCarritoExtrusion'

let parametros,
  parametros_usados = ['mostrar_iva']

const CarritoExtrusion = () => {
  const pedido = useSelector(state => state.pedidos.pedido)
  const portal = useSelector(state => state.portal.portal)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)
  const precio = useSelector(state => state.precios.precio)

  parametros = cargarParametros(parametros_usados, portal.parametros_ecom, 'CEX')

  const lineasPedido = (
    <Fragment>
      {!pedido?.lineas || pedido.lineas.length === 0
        ? ''
        : pedido.lineas
            .filter(linea => linea.tipo_linea === 'P')
            .map(linea => (
              <LineaCarritoExtrusion
                key={linea.numero_linea}
                linea={linea}
              />
            ))}
      {!pedido?.lineas || pedido.lineas.length === 0 ? (
        ''
      ) : (
        <div
          className='container lineas-pedido tt-shopcart-table'
          style={{ fontSize: '16px', fontWeight: '600', padding: '10px' }}>
          <div className='row linea-carrito'>
            <div className='col-9'>
              {i18n.t('articulos_extrusion.lbltotal').toUpperCase() + ':'}
            </div>
            <div
              className='col-3'
              style={{ display: 'flex', justifyContent: 'left' }}>
              {!pedido?.lineas || pedido.lineas.length === 0
                ? 0
                : Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: moneda,
                  }).format(
                    Number.parseFloat(
                      pedido.lineas
                        .filter(linea => linea.tipo_linea === 'P')
                        .map(linea => {
                          return Number.parseFloat(
                            (
                              precio?.[linea.articulo]?.[linea.presentacion_pedido]
                                ?.importe_bruto || 0
                            )
                              .toString()
                              .replace(/,/g, '.'),
                          )
                        })
                        .reduce((accumulator, currentValue) => accumulator + currentValue),
                    ).toFixed(2),
                  )}
            </div>
          </div>
          {parametros?.mostrar_iva === 'S' && (
            <div className='row linea-carrito'>
              <div className='col-9'>{i18n.t('articulos_extrusion.lbltotiva') + ':'}</div>
              <div
                className='col-3'
                style={{ display: 'flex', justifyContent: 'left' }}>
                {!pedido?.lineas || pedido.lineas.length === 0
                  ? 0
                  : new Intl.NumberFormat(locale, {
                      style: 'currency',
                      currency: moneda,
                    }).format(
                      Number.parseFloat(
                        pedido.lineas
                          .filter(linea => linea.tipo_linea === 'P')
                          .map(linea => {
                            let impuesto_articulo = 0
                            if (
                              precio[linea.articulo] !== undefined &&
                              !Array.isArray(
                                precio[linea.articulo][linea.presentacion_pedido].impuesto_articulo,
                              ) &&
                              precio[linea.articulo][linea.presentacion_pedido]
                                .impuesto_articulo !== null
                            ) {
                              impuesto_articulo =
                                Number.parseInt(
                                  precio[linea.articulo][linea.presentacion_pedido]
                                    .impuesto_articulo,
                                ) / 100
                            }

                            return (
                              Number.parseFloat(linea.importe_bruto_lin) * (1 + impuesto_articulo)
                            )
                          })
                          .reduce((accumulator, currentValue) => {
                            return accumulator + currentValue
                          }),
                      ).toFixed(2),
                    )}
              </div>
            </div>
          )}
        </div>
      )}
    </Fragment>
  )

  return (
    <div className='container-indent carrito-menu-extrusion'>
      <h1 className='tt-title'>{i18n.t('articulos_extrusion.titdetped')}</h1>
      {lineasPedido}
    </div>
  )
}

export default CarritoExtrusion
